import Select from "react-select";

const FilterSelect = ({
  label,
  name,
  options,
  value,
  onChange,
  placeholder,
}) => (
  <>
    <div className="row">
      <label className="col-sm-12 form-control-label label">{label}</label>
    </div>
    <div className="form-group row">
      <div className="col-sm-12">
        <Select
          name={name}
          isMulti={true}
          options={options}
          className="basic-multi-select fields-font"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        />
      </div>
    </div>
  </>
);

export default FilterSelect;
